export default __webpack_public_path__ + "static/Virtual-environment-6a4b72310195c05ca70e5a3f823dffc4.webp";